'use strict';

import Logger from '../utils/Logger';
import axios from 'axios';
import Urls from '../definitions/Urls';

const { id: module_id } = module;
const logger = Logger(module_id);

function makeResourceUrl(resourceId) {
  return `${Urls.apiUrl()}/${resourceId}`;
}

let client = (url, init) => {
  if (url === undefined || init === undefined) {
    throw new Error(
      'Expected 2 parameters, url and init on call to client method'
    );
  }
  logger.debug('[url:', url, '][init:', init, ']');
  return axios(makeResourceUrl(url), { ...init, withCredentials: true });
};

export default client;
